export default "__VITE_ASSET__DdMZGDPJ__"